/**
 * The one sentence that says advice rests on estimated searches, on a site without Search Console
 * (owner, 2026-10-20: it works without Search Console and says results would be better with it;
 * TECHNICAL_DEBT §0cj). Every pair item (the Cannibalization card on `/review`, the agent export and
 * the MCP, the "checked and fine" lines included) and the unclustered merge advice end with it, so a
 * reader sees one warning, worded once. Client-facing: no internal references in it.
 *
 * Where Search Console is connected for the domain nothing estimated is read for its pairs, so the
 * sentence never appears there.
 */
export const ESTIMATED_SEARCH_EVIDENCE_WARNING =
  "These searches are estimated from our crawl's rankings and stored search results, not measured; results would be better with Search Console connected.";
